import React, { useRef } from 'react';
import classnames from 'classnames';
import { getSettings } from '../util/getSettings';
import useOutsideClick from '../util/useOutsideClick';

const CLOSE_ICON = require('../../../Century.Website/wwwroot/Assets/icons/icon-close.svg');

const FilterModal = ({ 
  children, 
  open, 
  onClear, 
  onSave, 
  closeModal, 
  positionLeft, 
  mobile = false, 
  displayCloseBtn = false, 
  hideFooter = false, 
  stateFilter = false, 
  metroFilter = false, 
  containerId 
}) => {
  const ref = useRef();
  const labels = getSettings(['century', 'labels'], true);

  useOutsideClick(ref, () => {
    if (open) {
      closeModal();
    }
  });

  const closeIcon = {
    backgroundImage: `url("${CLOSE_ICON}")`,
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    height: 13,
    width: 13
  };

  if (mobile) {
    hideFooter = false;
  }

  return open ? (
    <div id={containerId} className={classnames('filter-modal-container', { 'position-left': positionLeft, mobile: mobile, 'state-filter': stateFilter, 'metro-filter': metroFilter })} ref={ref}>
      {displayCloseBtn && <div className="close-btn" style={closeIcon} onClick={closeModal}></div>}
      <div className={classnames({'filter-components': !stateFilter})}>{children}</div>
      {!hideFooter && <div className="filter-btn-container">
        <div>
          <button className="save-btn btn btn-primary" onClick={onSave}>
            {labels.saveLabel}
          </button>
        </div>
        <div>
          <span className='sr-only'>{labels.clearLabelScreenOnlyText}</span>
          <button className="clear-btn" onClick={onClear}>
            {labels.clearLabel}
          </button>
        </div>
      </div>}
    </div>
  ) : null;
};

export default FilterModal;
